import React from 'react'
import links from 'links'
import { track } from 'analytics'
import { useUser } from 'modules/user'

import { Text } from 'components/dataDisplay'
import { Href } from 'components/navigation'
import { buttonMessages } from 'components/inputs'


const UserNavWrapper: React.FunctionComponent<{ children: React.ReactElement }> = ({ children }) => {
  const { isLoggedIn, isFetching } = useUser()

  if (isFetching) {
    return null
  }

  if (!isLoggedIn) {
    return (
      <Href
        to={links.login}
        onClick={() => {
          track('Login button click')
        }}
      >
        <Text message={buttonMessages.login} style="t2" />
      </Href>
    )
  }

  return children
}


export default UserNavWrapper
